// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file knop/ui/v1/api/plan_train_unit_details.proto (package knop.ui.v1.api, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Duration, Message, proto3, Timestamp } from "@bufbuild/protobuf";
import { ResponseStatus } from "./util/response_status_pb.js";
import { ServiceTask, ServiceTask_ServiceTaskType } from "../model/servicetask_pb.js";

/**
 * @generated from message knop.ui.v1.api.PlanTrainUnitDetailsRequest
 */
export class PlanTrainUnitDetailsRequest extends Message<PlanTrainUnitDetailsRequest> {
  /**
   * @generated from field: string instance_id = 1;
   */
  instanceId = "";

  constructor(data?: PartialMessage<PlanTrainUnitDetailsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.api.PlanTrainUnitDetailsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "instance_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PlanTrainUnitDetailsRequest {
    return new PlanTrainUnitDetailsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PlanTrainUnitDetailsRequest {
    return new PlanTrainUnitDetailsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PlanTrainUnitDetailsRequest {
    return new PlanTrainUnitDetailsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: PlanTrainUnitDetailsRequest | PlainMessage<PlanTrainUnitDetailsRequest> | undefined, b: PlanTrainUnitDetailsRequest | PlainMessage<PlanTrainUnitDetailsRequest> | undefined): boolean {
    return proto3.util.equals(PlanTrainUnitDetailsRequest, a, b);
  }
}

/**
 * @generated from message knop.ui.v1.api.PlanTrainUnitDetailsResponse
 */
export class PlanTrainUnitDetailsResponse extends Message<PlanTrainUnitDetailsResponse> {
  /**
   * @generated from field: repeated knop.ui.v1.api.PlanTrainUnitDetails plan_train_unit_details_list = 1;
   */
  planTrainUnitDetailsList: PlanTrainUnitDetails[] = [];

  /**
   * @generated from field: knop.ui.v1.api.util.ResponseStatus status = 2;
   */
  status = ResponseStatus.UNKNOWN;

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  constructor(data?: PartialMessage<PlanTrainUnitDetailsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.api.PlanTrainUnitDetailsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "plan_train_unit_details_list", kind: "message", T: PlanTrainUnitDetails, repeated: true },
    { no: 2, name: "status", kind: "enum", T: proto3.getEnumType(ResponseStatus) },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PlanTrainUnitDetailsResponse {
    return new PlanTrainUnitDetailsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PlanTrainUnitDetailsResponse {
    return new PlanTrainUnitDetailsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PlanTrainUnitDetailsResponse {
    return new PlanTrainUnitDetailsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: PlanTrainUnitDetailsResponse | PlainMessage<PlanTrainUnitDetailsResponse> | undefined, b: PlanTrainUnitDetailsResponse | PlainMessage<PlanTrainUnitDetailsResponse> | undefined): boolean {
    return proto3.util.equals(PlanTrainUnitDetailsResponse, a, b);
  }
}

/**
 * @generated from message knop.ui.v1.api.PlanTrainUnitDetails
 */
export class PlanTrainUnitDetails extends Message<PlanTrainUnitDetails> {
  /**
   * @generated from field: string ptu_guid = 1;
   */
  ptuGuid = "";

  /**
   * @generated from field: string train_unit_kind = 2;
   */
  trainUnitKind = "";

  /**
   * @generated from field: knop.ui.v1.api.PlanTrainUnitDetails.TransitionType transition = 3;
   */
  transition = PlanTrainUnitDetails_TransitionType.UNKNOWN;

  /**
   * @generated from field: google.protobuf.Duration transition_duration = 4;
   */
  transitionDuration?: Duration;

  /**
   * @generated from field: repeated knop.ui.v1.model.ServiceTask service_tasks = 5;
   */
  serviceTasks: ServiceTask[] = [];

  /**
   * @generated from field: repeated string claims = 6;
   */
  claims: string[] = [];

  /**
   * @generated from field: string appearing_train_unit_name = 7;
   */
  appearingTrainUnitName = "";

  /**
   * @generated from field: string appearing_track_name = 8;
   */
  appearingTrackName = "";

  /**
   * @generated from field: google.protobuf.Timestamp appearing_time = 9;
   */
  appearingTime?: Timestamp;

  /**
   * @generated from field: string disappearing_train_unit_name = 10;
   */
  disappearingTrainUnitName = "";

  /**
   * @generated from field: string disappearing_track_name = 11;
   */
  disappearingTrackName = "";

  /**
   * @generated from field: google.protobuf.Timestamp disappearing_time = 12;
   */
  disappearingTime?: Timestamp;

  /**
   * @generated from field: knop.ui.v1.api.PlanTrainUnitDetails.MatchingChangeability matching_changeability = 13;
   */
  matchingChangeability = PlanTrainUnitDetails_MatchingChangeability.MATCHING_CHANGEABILITY_UNKNOWN;

  constructor(data?: PartialMessage<PlanTrainUnitDetails>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.api.PlanTrainUnitDetails";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ptu_guid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "train_unit_kind", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "transition", kind: "enum", T: proto3.getEnumType(PlanTrainUnitDetails_TransitionType) },
    { no: 4, name: "transition_duration", kind: "message", T: Duration },
    { no: 5, name: "service_tasks", kind: "message", T: ServiceTask, repeated: true },
    { no: 6, name: "claims", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 7, name: "appearing_train_unit_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "appearing_track_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "appearing_time", kind: "message", T: Timestamp },
    { no: 10, name: "disappearing_train_unit_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "disappearing_track_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "disappearing_time", kind: "message", T: Timestamp },
    { no: 13, name: "matching_changeability", kind: "enum", T: proto3.getEnumType(PlanTrainUnitDetails_MatchingChangeability) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PlanTrainUnitDetails {
    return new PlanTrainUnitDetails().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PlanTrainUnitDetails {
    return new PlanTrainUnitDetails().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PlanTrainUnitDetails {
    return new PlanTrainUnitDetails().fromJsonString(jsonString, options);
  }

  static equals(a: PlanTrainUnitDetails | PlainMessage<PlanTrainUnitDetails> | undefined, b: PlanTrainUnitDetails | PlainMessage<PlanTrainUnitDetails> | undefined): boolean {
    return proto3.util.equals(PlanTrainUnitDetails, a, b);
  }
}

/**
 * @generated from enum knop.ui.v1.api.PlanTrainUnitDetails.TransitionType
 */
export enum PlanTrainUnitDetails_TransitionType {
  /**
   * @generated from enum value: UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: DAY = 1;
   */
  DAY = 1,

  /**
   * @generated from enum value: NIGHT = 2;
   */
  NIGHT = 2,

  /**
   * @generated from enum value: NIGHT_OUTSIDE_SCENARIO = 3;
   */
  NIGHT_OUTSIDE_SCENARIO = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(PlanTrainUnitDetails_TransitionType)
proto3.util.setEnumType(PlanTrainUnitDetails_TransitionType, "knop.ui.v1.api.PlanTrainUnitDetails.TransitionType", [
  { no: 0, name: "UNKNOWN" },
  { no: 1, name: "DAY" },
  { no: 2, name: "NIGHT" },
  { no: 3, name: "NIGHT_OUTSIDE_SCENARIO" },
]);

/**
 * @generated from enum knop.ui.v1.api.PlanTrainUnitDetails.MatchingChangeability
 */
export enum PlanTrainUnitDetails_MatchingChangeability {
  /**
   * @generated from enum value: MATCHING_CHANGEABILITY_UNKNOWN = 0;
   */
  MATCHING_CHANGEABILITY_UNKNOWN = 0,

  /**
   * @generated from enum value: FIXED = 1;
   */
  FIXED = 1,

  /**
   * @generated from enum value: PINNED = 2;
   */
  PINNED = 2,

  /**
   * @generated from enum value: OPEN = 3;
   */
  OPEN = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(PlanTrainUnitDetails_MatchingChangeability)
proto3.util.setEnumType(PlanTrainUnitDetails_MatchingChangeability, "knop.ui.v1.api.PlanTrainUnitDetails.MatchingChangeability", [
  { no: 0, name: "MATCHING_CHANGEABILITY_UNKNOWN" },
  { no: 1, name: "FIXED" },
  { no: 2, name: "PINNED" },
  { no: 3, name: "OPEN" },
]);

/**
 * @generated from message knop.ui.v1.api.PlanServiceTaskRequest
 */
export class PlanServiceTaskRequest extends Message<PlanServiceTaskRequest> {
  /**
   * @generated from field: string plan_train_unit_guid = 1;
   */
  planTrainUnitGuid = "";

  /**
   * @generated from field: knop.ui.v1.model.ServiceTask.ServiceTaskType service_task_type = 2;
   */
  serviceTaskType = ServiceTask_ServiceTaskType.UNKNOWN;

  /**
   * @generated from field: string instance_id = 3;
   */
  instanceId = "";

  constructor(data?: PartialMessage<PlanServiceTaskRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.api.PlanServiceTaskRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "plan_train_unit_guid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "service_task_type", kind: "enum", T: proto3.getEnumType(ServiceTask_ServiceTaskType) },
    { no: 3, name: "instance_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PlanServiceTaskRequest {
    return new PlanServiceTaskRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PlanServiceTaskRequest {
    return new PlanServiceTaskRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PlanServiceTaskRequest {
    return new PlanServiceTaskRequest().fromJsonString(jsonString, options);
  }

  static equals(a: PlanServiceTaskRequest | PlainMessage<PlanServiceTaskRequest> | undefined, b: PlanServiceTaskRequest | PlainMessage<PlanServiceTaskRequest> | undefined): boolean {
    return proto3.util.equals(PlanServiceTaskRequest, a, b);
  }
}

/**
 * @generated from message knop.ui.v1.api.PlanServiceTaskResponse
 */
export class PlanServiceTaskResponse extends Message<PlanServiceTaskResponse> {
  /**
   * @generated from field: knop.ui.v1.api.util.ResponseStatus status = 1;
   */
  status = ResponseStatus.UNKNOWN;

  /**
   * @generated from field: string description = 2;
   */
  description = "";

  constructor(data?: PartialMessage<PlanServiceTaskResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.api.PlanServiceTaskResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(ResponseStatus) },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PlanServiceTaskResponse {
    return new PlanServiceTaskResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PlanServiceTaskResponse {
    return new PlanServiceTaskResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PlanServiceTaskResponse {
    return new PlanServiceTaskResponse().fromJsonString(jsonString, options);
  }

  static equals(a: PlanServiceTaskResponse | PlainMessage<PlanServiceTaskResponse> | undefined, b: PlanServiceTaskResponse | PlainMessage<PlanServiceTaskResponse> | undefined): boolean {
    return proto3.util.equals(PlanServiceTaskResponse, a, b);
  }
}

/**
 * @generated from message knop.ui.v1.api.UnplanServiceTaskRequest
 */
export class UnplanServiceTaskRequest extends Message<UnplanServiceTaskRequest> {
  /**
   * @generated from field: string plan_train_unit_guid = 1;
   */
  planTrainUnitGuid = "";

  /**
   * @generated from field: knop.ui.v1.model.ServiceTask.ServiceTaskType service_task_type = 2;
   */
  serviceTaskType = ServiceTask_ServiceTaskType.UNKNOWN;

  /**
   * @generated from field: string instance_id = 3;
   */
  instanceId = "";

  constructor(data?: PartialMessage<UnplanServiceTaskRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.api.UnplanServiceTaskRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "plan_train_unit_guid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "service_task_type", kind: "enum", T: proto3.getEnumType(ServiceTask_ServiceTaskType) },
    { no: 3, name: "instance_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UnplanServiceTaskRequest {
    return new UnplanServiceTaskRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UnplanServiceTaskRequest {
    return new UnplanServiceTaskRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UnplanServiceTaskRequest {
    return new UnplanServiceTaskRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UnplanServiceTaskRequest | PlainMessage<UnplanServiceTaskRequest> | undefined, b: UnplanServiceTaskRequest | PlainMessage<UnplanServiceTaskRequest> | undefined): boolean {
    return proto3.util.equals(UnplanServiceTaskRequest, a, b);
  }
}

/**
 * @generated from message knop.ui.v1.api.UnplanServiceTaskResponse
 */
export class UnplanServiceTaskResponse extends Message<UnplanServiceTaskResponse> {
  /**
   * @generated from field: knop.ui.v1.api.util.ResponseStatus status = 1;
   */
  status = ResponseStatus.UNKNOWN;

  /**
   * @generated from field: string description = 2;
   */
  description = "";

  constructor(data?: PartialMessage<UnplanServiceTaskResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.api.UnplanServiceTaskResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(ResponseStatus) },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UnplanServiceTaskResponse {
    return new UnplanServiceTaskResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UnplanServiceTaskResponse {
    return new UnplanServiceTaskResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UnplanServiceTaskResponse {
    return new UnplanServiceTaskResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UnplanServiceTaskResponse | PlainMessage<UnplanServiceTaskResponse> | undefined, b: UnplanServiceTaskResponse | PlainMessage<UnplanServiceTaskResponse> | undefined): boolean {
    return proto3.util.equals(UnplanServiceTaskResponse, a, b);
  }
}

/**
 * @generated from message knop.ui.v1.api.PinTransitionRequest
 */
export class PinTransitionRequest extends Message<PinTransitionRequest> {
  /**
   * @generated from field: string plan_train_unit_guid = 1;
   */
  planTrainUnitGuid = "";

  /**
   * @generated from field: string instance_id = 2;
   */
  instanceId = "";

  constructor(data?: PartialMessage<PinTransitionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.api.PinTransitionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "plan_train_unit_guid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "instance_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PinTransitionRequest {
    return new PinTransitionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PinTransitionRequest {
    return new PinTransitionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PinTransitionRequest {
    return new PinTransitionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: PinTransitionRequest | PlainMessage<PinTransitionRequest> | undefined, b: PinTransitionRequest | PlainMessage<PinTransitionRequest> | undefined): boolean {
    return proto3.util.equals(PinTransitionRequest, a, b);
  }
}

/**
 * @generated from message knop.ui.v1.api.PinTransitionResponse
 */
export class PinTransitionResponse extends Message<PinTransitionResponse> {
  /**
   * @generated from field: knop.ui.v1.api.util.ResponseStatus status = 1;
   */
  status = ResponseStatus.UNKNOWN;

  /**
   * @generated from field: string description = 2;
   */
  description = "";

  constructor(data?: PartialMessage<PinTransitionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.api.PinTransitionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(ResponseStatus) },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PinTransitionResponse {
    return new PinTransitionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PinTransitionResponse {
    return new PinTransitionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PinTransitionResponse {
    return new PinTransitionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: PinTransitionResponse | PlainMessage<PinTransitionResponse> | undefined, b: PinTransitionResponse | PlainMessage<PinTransitionResponse> | undefined): boolean {
    return proto3.util.equals(PinTransitionResponse, a, b);
  }
}

/**
 * @generated from message knop.ui.v1.api.UnpinTransitionRequest
 */
export class UnpinTransitionRequest extends Message<UnpinTransitionRequest> {
  /**
   * @generated from field: string plan_train_unit_guid = 1;
   */
  planTrainUnitGuid = "";

  /**
   * @generated from field: string instance_id = 2;
   */
  instanceId = "";

  constructor(data?: PartialMessage<UnpinTransitionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.api.UnpinTransitionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "plan_train_unit_guid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "instance_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UnpinTransitionRequest {
    return new UnpinTransitionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UnpinTransitionRequest {
    return new UnpinTransitionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UnpinTransitionRequest {
    return new UnpinTransitionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UnpinTransitionRequest | PlainMessage<UnpinTransitionRequest> | undefined, b: UnpinTransitionRequest | PlainMessage<UnpinTransitionRequest> | undefined): boolean {
    return proto3.util.equals(UnpinTransitionRequest, a, b);
  }
}

/**
 * @generated from message knop.ui.v1.api.UnpinTransitionResponse
 */
export class UnpinTransitionResponse extends Message<UnpinTransitionResponse> {
  /**
   * @generated from field: knop.ui.v1.api.util.ResponseStatus status = 1;
   */
  status = ResponseStatus.UNKNOWN;

  /**
   * @generated from field: string description = 2;
   */
  description = "";

  constructor(data?: PartialMessage<UnpinTransitionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.api.UnpinTransitionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(ResponseStatus) },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UnpinTransitionResponse {
    return new UnpinTransitionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UnpinTransitionResponse {
    return new UnpinTransitionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UnpinTransitionResponse {
    return new UnpinTransitionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UnpinTransitionResponse | PlainMessage<UnpinTransitionResponse> | undefined, b: UnpinTransitionResponse | PlainMessage<UnpinTransitionResponse> | undefined): boolean {
    return proto3.util.equals(UnpinTransitionResponse, a, b);
  }
}

